import React from 'react';
import NameDefinition from './NameDefinition';
import Icon from '@mdi/react';
import PropTypes from 'prop-types';
import { mdiBullseyeArrow } from '@mdi/js';

const CpaDefinition = ({
  textFormat = 'text-xs font-semibold w-fit text-background-dark',
  definiton = 'Cost Per Acquisition',
  name = 'CPA',
  size,
  showIcon,
}) => {
  return (
    <div className='flex items-center gap-2'>
      {showIcon && <Icon path={mdiBullseyeArrow} size={0.8} className='text-orange' />}
      <NameDefinition name={name} definiton={definiton} textSize={textFormat} size={size} />
    </div>
  );
};

export default CpaDefinition;

CpaDefinition.propTypes = {
  textFormat: PropTypes.string,
};
